import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from "./components/LandingPage/Home";
import NotFound from "./components/LandingPage/NotFound"; // Yangi yaratgan 404 komponenting
import PrivacyPolicy from './privacy/PrivacyPolicy';
import DownloadApp from './components/LandingPage//Download/DownloadApp';

// Alohida kichik Redirect komponenti yaratib olamiz
function SurveyRedirect() {
  useEffect(() => {
    window.location.href = "https://survey-dev-core-uciv-git-main-phettcti-2204s-projects.vercel.app/";
  }, []);

  return (
    <div style={{ textAlign: 'center', marginToP: '50px', fontFamily: 'sans-serif' }}>
      <h2>Yo'naltirilmoqda...</h2>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/download-app" element={<DownloadApp />} />
        
        {/* FAQAT SHU MANZILGA KIRILGANDA ISHLAYDI */}
        <Route path="/survey" element={<SurveyRedirect />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}